import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';

import { getListAdmin, getTypes, remove } from '../../../redux/article/actions';
import {
  loading,
  listAdmin,
  listAdminCount,
} from '../../../redux/article/selectors';
import { list, defaultLang } from '../../../redux/lang/selectors';
import ArticleListPage from './ArticleListPage';

const selector = createStructuredSelector({
  loading,
  list: listAdmin,
  allCount: listAdminCount,
  langList: list,
  defaultLang,
});

const actions = {
  getListAdmin,
  getTypes,
  remove,
};

export { ArticleListPage };

export default connect(selector, actions)(ArticleListPage);
